import React, { useEffect, useState } from 'react'
import { useGetAdultEvnetsById } from 'api/family/adult'
import Spinner from 'components/Spinner'
import { GetEventParams } from 'types/event/events'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
import EventCard from 'components/Events/Views/CardView/SingleCard'
import { Pagination } from 'antd'
import EmptyData from 'components/global/EmptyData'

interface AdultEventsProps {
  adultId: string
}

const Events: React.FC<AdultEventsProps> = ({ adultId }) => {
  const [param, setParams] = useState<GetEventParams>({
    page: undefined,
    limit: undefined,
  })
  const { updateRouteParams } = useSyncParamsWithRoute(param, setParams)
  const PaginationChanger = (pagenumber: number, limit: number) => {
    updateRouteParams({ page: pagenumber, limit: limit })
  }
  const { data, isLoading, isFetching, refetch } = useGetAdultEvnetsById(
    adultId,
    param,
  )

  useEffect(() => {
    if (param.page) {
      refetch()
    }
  }, [param])

  return (
    <div className="bg-grey  padding-top-10">
      <div className="bg-white p-30px">
        {isFetching || isLoading ? (
          <div className="bg-white flex justify-center align-center">
            <Spinner />
          </div>
        ) : data?.records?.length ? (
          <>
            {data.records.map((event: any) => {
              return <EventCard event={event} key={event._id} />
            })}
            <div className="mb-20px mt-20px">
              {(data?.hasNextPage || data?.hasPrevPage) && (
                <div className="text-right">
                  <Pagination
                    onChange={PaginationChanger}
                    defaultCurrent={param.page}
                    total={data.count}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                    pageSize={param.limit || 10}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div>
            <EmptyData message="No events" />
          </div>
        )}
      </div>
    </div>
  )
}

export default Events
